<template>
<div class='risk-score-details-table'>
  <div class='risk-score-details-table__header'>
    <span class='header-label'>
        {{ $t('risk.score.details.table.header') }}
    </span>
    <div class="risk-score-details-table__info">
      <a href='https://kb.cynergy.app/space/GS/912523265' target='_blank'>
        <v-icon class='risk-score-details-table__info__icon material-icons-outlined'>info</v-icon>
      </a>
    </div>
  </div>
  <div class='risk-score-details-table__content'>
    <risk-score-indicator v-for='(value, index) in series'  :key='`series-indicator-${index}`'
      :value='normalizedValue(index,value)'
      :title='`${title}.${labels[index]}`'
      :subtitle='subtitleFormatted(value, index)'
      :data-missing='missingData[labels[index]]'
      :domains='domains'
    />
  </div>
</div>
</template>

<script>
import RiskScoreIndicator from '@/components/risk-score/RiskScoreIndicator.vue';
import { advancedRound } from '@/utils/numberUtils';

export default {
  name: 'RiskScoreDetailsTable',
  components: { RiskScoreIndicator },
  props: {
    missingData: {
      type: Object,
      default: () => ({
        hijack: false,
        smtp: false,
        dns: false,
        cloud: false,
        dataleaks: false,
        employees: false,
        waf: false,
        tech: false,
        ports: false,
      }),
    },
    series: {
      type: Array,
      required: true,
      default: () => [],
    },
    seriesMax: {
      type: Array,
      required: false,
      default: () => [],
    },
    labels: {
      type: Array,
      required: true,
      default: () => [],
    },
    domains: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    title: 'risk.score.details.table.title',
    subtitle: 'risk.score.details.table.subtitle',
  }),
  methods: {
    subtitleFormatted(value, index) {
      if (this.missingData[this.labels[index]]) {
        return 'risk.score.data.missing';
      }
      return `${this.subtitle}.${this.labels[index]}`;
    },
    normalizedValue(index, value) {
      return this.missingData[this.labels[index]] ? value : advancedRound((100 * value) / this.seriesMax[index]);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/styles/design-system";
.risk-score-details-table{
  display: flex;
  flex-direction: column;
  padding-top: $space-9;
  padding-left: $space-9;
  &__header{
    display: flex;
    flex-direction: row;
    .header-label{
      color: var(--text-primary);
      font-family: $font-family-black;
      font-size: $font-size-md;
      line-height: $space-5;
      letter-spacing: 0;
    }
  }
  &__info{
    margin-top: rem(-12);
    margin-left: $space-1;
    &__icon {
      color: var(--text-secondary);
      font-size: $font-size-md;
    }
  }
}

</style>
